import { useSearchParamsUtils } from 'app/hooks/useSearchParamsUtils';
import { ExplorerEntityTypes } from 'entities/types';
import { ExplorerInterface } from 'app/store/lib/explorers/explorerStore';
import { useEffect } from 'react';

export const useExplorerStore = (explorer: ExplorerInterface) => {
  const searchUtils = useSearchParamsUtils();

  const { type, id, in_trash } = searchUtils;

  useEffect(() => {
    // WARNING: currentSection - это ссылка на секцию в sectionsStore, все остальное - модели в вакууме
    explorer.setCurrentEntity(id, type);
  }, [type, id, explorer]);

  const { currentEntity } = explorer;

  useEffect(() => {
    // TODO: Актуально?
    // Секции из sectionStore зачастую подтягиваются позже остального, поэтому геттер currentSection тригерит паразитный вызов хука и дублирование запросов
    if (!currentEntity) {
      return;
    }

    currentEntity.model.fetch({ in_trash });

    if (currentEntity.type === ExplorerEntityTypes.TABLE) {
      currentEntity.model.fetchLinks({ in_trash });
    }
    if (currentEntity.type === ExplorerEntityTypes.FOLDER) {
      currentEntity.model.getContent({ in_trash });
    }
    if (currentEntity.type === ExplorerEntityTypes.SECTION) {
      currentEntity.model.getContent({ in_trash });
    }
  }, [currentEntity, in_trash]);

  return currentEntity;
};
